// extracted by mini-css-extract-plugin
export default {"socialLinks":"socialLinks_socialLinks__qB+1B"};